import { render } from "./detail-enterprise.vue?vue&type=template&id=230316d1&scoped=true&ts=true"
import script from "./detail-enterprise.vue?vue&type=script&lang=ts"
export * from "./detail-enterprise.vue?vue&type=script&lang=ts"

import "./detail-enterprise.vue?vue&type=style&index=0&id=230316d1&lang=scss&scoped=true"

import exportComponent from "/Users/star/Desktop/clz-frontend/taxi-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230316d1"]])

export default __exports__